/**
 * 日常点検ページ用のスクリプト
 */
if (is_route('navitime_analysis_company.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        navitime_analysis_company_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.navitime_analysis_company_event_set = function () {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        // 設定モーダルを表示
        _modal.create(this, 'setting-modal', ['id']);
    });

    /*---- 保存時 ----*/

    // 保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', function(results) {
        });
    });

}